var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 89"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.26 87.84H54.49L16.11 21.39h-.54c.76 11.74 1.15 20.11 1.15 25.11v41.34H0V0h23.59l38.32 65.79h.42c-.6-11.42-.91-19.49-.91-24.21V0h16.84v87.84z",
    fill: "#f59c27"
  })));
}
export default SvgN;